import getCategories from "utils/select_options/getCategories";
import getProducers from "utils/select_options/getProducers";
import getBrands from "utils/select_options/getBrands";
import product_kind_options from "utils/select_options/product_kind_options";

export const sort = [
  {
    label: "",
    name: "image",
    style: { width: 70 },
    sortable: false,
  },
  { label: "Nazwa", name: "name", style: { width: 350 } },
  { label: "SKU", name: "sku", style: { width: 130 } },
  { label: "Rodzaj", name: "kind", style: { width: 100 } },
  { label: "Kategoria", name: "root_taxon_id", style: { width: 200 } },
  { label: "Producent", name: "producer_id", style: { width: 140 } },
  { label: "Marka", name: "brand_id", style: { width: 140 } },
  { label: "Kod CN", name: "ai_cn_confidence", style: { width: 120 } },
  { label: "Kanały", name: "channels", sortable: false },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
  {
    type: "input",
    name: "sku",
    sort_id: "sku",
    search_type: "matches",
  },
  {
    type: "select",
    name: "kind",
    sort_id: "kind",
    search_type: "in",
    options: product_kind_options,
  },
  {
    type: "async_select",
    name: "producer_name",
    sort_id: "producer_id",
    search_type: "in",
    getData: getProducers,
  },
  {
    type: "async_select",
    name: "brand_name",
    sort_id: "brand_id",
    search_type: "in",
    getData: getBrands,
  },
  {
    type: "async_select",
    name: "root_taxon_name",
    sort_id: "root_taxon_id",
    search_type: "in",
    getData: getCategories,
  },
  {
    type: "input",
    name: "cn_code",
    sort_id: "ai_cn_confidence",
    search_type: "matches",
  },
];
